<template>
    <div class="app-main">
        <div class="top-bar">
          <el-button type="success" plain style="width:120px" @click="showDialog(1)">添加分类</el-button>
        </div>
        <el-card shadow="hover">
            <el-table ref="multipleTable" :data="tableData"  height="650" style="width: 100%">
                <el-table-column  align="center" label="分类图标">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.pic_url" :src="scope.row.pic_url" width="255" height="74" />
                    </template>
                </el-table-column>
                <el-table-column  align="center" label="英文图标">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.pic_url_en" :src="scope.row.pic_url_en" width="255" height="74" />
                    </template>
                </el-table-column>
                <el-table-column prop="title"  label="分类名称" align="center" ></el-table-column>
                <el-table-column prop="title_en"  label="英文名称" align="center" ></el-table-column>
                <el-table-column prop="sort_id"  label="排序" align="center" ></el-table-column>
                <el-table-column  align="center" label="编辑">
                    <template slot-scope="scope">
                        <el-button  @click="showDialog(2, scope.row)"  size="mini"  type="success" style="margin-bottom:5px">修改</el-button> <br />
                        <el-popconfirm @onConfirm="del(scope.row.id)" :title="`此操作将删除分类：${scope.row.title}`">
                            <el-button slot="reference" size="mini" type="danger" >删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <el-dialog title="分类编辑" :visible.sync="dialog" @closed="resetData" center class="dialog">
            <div class="dialog-content">
                
                <div style="width:50%">
                    <span>分类名称：</span>
                    <el-input v-model="row.title"  style="width:65%;margin-top:15px;"></el-input>
                </div>
                <div style="width:50%">
                    <span>英文名称：</span>
                    <el-input v-model="row.title_en"  style="width:65%;margin-top:15px;"></el-input>
                </div>
                <div style="width:50%">
                    <span>分类排序：</span>
                    <el-input v-model="row.sort_id"  style="width:65%;margin-top:15px;"></el-input>
                </div>
                <!-- <div style="width:50%;margin-top:15px;">
                    <span>是否食物：</span>
                    <el-radio v-model="row.is_food" :label="1" border size="medium">否</el-radio>
                    <el-radio v-model="row.is_food" :label="2" border size="medium">是</el-radio>
                </div> -->
                <div class="upload-box">
                    <span>分类图标：</span>
                    <m-upload :img.sync="row.pic" width="255" height="74" file-name="classify"  placement="right" />
                </div>
                <div class="upload-box">
                    <span>英文图标：</span>
                    <m-upload :img.sync="row.pic_en" width="255" height="74" file-name="classify"  placement="right" />
                </div>
            </div>
            <div slot="footer" class="dialog-footer" v-show="type == 1">
                <el-button @click="dialog = false" style="width:120px">取 消</el-button>
                <el-button type="primary" @click="add"  style="width:120px">添 加</el-button>
            </div>
            <div slot="footer" class="dialog-footer" v-show="type == 2">
                <el-button @click="dialog = false" style="width:120px">取 消</el-button>
                <el-button type="primary" @click="edit"  style="width:120px">修 改</el-button>
            </div>
        </el-dialog>

        
    </div>
</template>
<script>
import { classify_list, classify_add, classify_put, classify_del } from '@/api/goods.js'
import MUpload from './../../../components/m-upload'
import MImg    from './../../../components/Image'

export default {
    name:'classFirst',
    components: { MUpload, MImg },
    data () {
        return {
            tableData:[],
            dialog:false,
            type: 1,       // 1 添加  2 修改
            row: {
                title: '',
                title_en: '',
                pic: { pic_id: '', url: '' },
                pic_en: { pic_id: '', url: '' },
                is_food: 1,
                pid: 0,
                level: 1,
                sort_id: 1,
            },
        }
    },
    methods:{
        getList(){
            let params = {
                level:1,
            }
            classify_list(params).then(res => {
                if(res) {
                    this.tableData = res.data
                }else{
                    this.$message.error(res.msg)
                }
            }).catch( () => {
                this.tableLoad = false;
            })
        },

        //  显示弹窗
        showDialog(type, row) {
            this.type = type
            if(type == 2) {
                this.row = row
                this.row.pic = {
                    pic_id : row.logo_pic,
                    url: row.pic_url
                }
                this.row.pic_en = {
                    pic_id : row.logo_pic_en,
                    url: row.pic_url_en
                }
            }
            this.dialog = true
        },

       

        add(){
            let params = {
                title: this.row.title,
                title_en: this.row.title_en,
                logo_pic: this.row.pic.pic_id,
                logo_pic_en: this.row.pic_en.pic_id,
                is_food: this.row.is_food,
                pid: this.row.pid,
                level: this.row.level,
                sort_id: this.row.sort_id,
            }

            if( !this.validate(params)) {
                this.$message.error('请完善分类信息')
                return false
            }

            classify_add(params).then(res => {
                if(res){
                    this.$message({ type: 'success', message: res.msg })
                    this.dialog = false
                    this.getList()
                }else{
                    this.$message.error(res.msg)
                }
            })
        },
        del(id){
            classify_del(id).then(res => {
                if(res){
                    this.$message({ type: 'success', message: res.msg })
                    this.getList();
                }else{
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        edit(){

            let params = {
                title: this.row.title,
                title_en: this.row.title_en,
                logo_pic: this.row.pic.pic_id,
                logo_pic_en: this.row.pic_en.pic_id,
                is_food: this.row.is_food,
                pid: this.row.pid,
                level: this.row.level,
                sort_id: this.row.sort_id,
            }
            
            if( !this.validate(params)) {
                this.$message.error('请完善分类信息')
                return false
            }

            classify_put(this.row.id,params).then(res => {
                if(res){
                    this.$message({ type: 'success', message: res.msg })
                    this.dialog = false
                    this.getList();
                }else{
                    this.dialog = false
                    this.$message.error(res.msg)     
                }
            })
        },

        positionUp(index,row){
            console.log(index)
            if(index !== 0 ){
                let obj1 = {
                    id:row.id,
                    sort:this.tableData[index-1].sort
                }
                const obj2 = {
                    id:this.tableData[index-1].id,
                    sort:row.sort
                }
                const data  = []
                data.push(obj1);
                data.push(obj2);
                let params = {
                    data:data,
                }
                this.tableLoad = true;
                classify_put(params).then(res => {
                if(res.status === 1){
                    this.$message(res.msg)
                    this.getList();
                }else{
                    this.tableLoad = false;
                    this.$message.error(res.msg)     
                }
            }).catch(err => {
                this.tableLoad = false;
                console.log(err)
            })

            }else{
                this.$message.error("已经是第一位了，不能在往上了哦...")  
            }
        },
        positionDown(index,row){
            console.log(index)
            if(index+1 !== this.tableData.length ){
                let obj1 = {
                    id:row.id,
                    sort:this.tableData[index+1].sort
                }
                const obj2 = {
                    id:this.tableData[index+1].id,
                    sort:row.sort
                }
                const data  = []
                data.push(obj1);
                data.push(obj2);
                let params = {
                    data:data,
                }
                this.tableLoad = true;
                classify_put(params).then(res => {
                if(res.status === 1){
                    this.$message(res.msg)
                    this.getList();
                }else{
                    this.tableLoad = false;
                    this.$message.error(res.msg)     
                }
            }).catch(err => {
                this.tableLoad = false;
                console.log(err)
            })
            }else{
                this.$message.error("已经是最后一位了，不能在往下了哦...")  
            }
        },
        resetData() {
            this.row = {
                title: '',
                title_en: '',
                is_food: 1,
                pid: 0,
                level: 1,
                sort_id: 1,
                pic: { pic_id: '', url: '' },
                pic_en: { pic_id: '', url: '' },
            }
        }
    },
    mounted(){
        this.getList();
    },
    activated() {
        this.getList()
    },
}
</script>
<style lang="less" scoped>
.dialog {
    .m-bottom {
        margin-bottom: 5px;
    }
    .dialog-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        .upload-box {
            width: 50%;
            margin-top: 15px;
            display: flex;
            align-items: flex-start;
        }
    }
}
</style>


